import { createFileRoute } from '@tanstack/react-router'
import { useEffect, useState } from 'react'
import { useCurrentAssistant, useUpdateAssistant } from '~/api'
import { AppHeading } from '~/components/educator/app/AppHeading'
import { Button, Input, Label, Textarea } from '~ui'

export const Route = createFileRoute('/educator/courses/$courseId/apps/$appId/details')({
	component: AppDetails,
})

function AppDetails() {
	const app = useCurrentAssistant()
	const { mutate: updateAssistant } = useUpdateAssistant()
	const [name, setName] = useState('')
	const [description, setDescription] = useState('')
	const [openingMessage, setOpeningMessage] = useState('')

	useEffect(() => {
		if (app) {
			setName(app.name)
			setDescription(app.description ?? '')
			setOpeningMessage(app.openingMessage ?? '')
		}
	}, [app])

	if (!app) return

	const disabled = app.isGlobal === true || app.isTemplate === true

	return (
		<>
			<AppHeading>
				{!disabled && (
					<Button
						disabled={name === '' || description === ''}
						onClick={() => {
							updateAssistant({
								...app,
								name,
								description,
								openingMessage,
							})
						}}
					>
						Update details
					</Button>
				)}
			</AppHeading>
			<h1 className="mb-[4px]">Details</h1>
			<p className="mb-[24px]">Edit the name, description, and student-facing details for this app.</p>
			<div className="mb-[24px]">
				<Label>Name</Label>
				<Input
					name="name"
					value={name}
					onChange={(e) => {
						setName(e.target.value)
					}}
					disabled={disabled}
					maxLength={50}
				/>
				<div className="text-dark-grey-100 dark:text-light-grey-50 mt-[8px] text-[14px]">{name.length}/50</div>
			</div>
			<div className="mb-[24px]">
				<Label>Description</Label>
				<Textarea
					name="description"
					value={description}
					onChange={(e) => {
						setDescription(e.target.value)
					}}
					disabled={disabled}
					maxLength={300}
					className="min-h-[64px]"
				/>
				<div className="text-dark-grey-100 dark:text-light-grey-50 mt-[8px] text-[14px]">{description.length}/300</div>
			</div>
			<div className="mb-[24px]">
				<Label
					width="text"
					infoTooltip="The opening message appears at the top of the chat. It sets the tone for how Aila will support students and signals that the app is ready."
				>
					Opening message
				</Label>
				<Textarea
					name="opening-message"
					value={openingMessage}
					onChange={(e) => {
						setOpeningMessage(e.target.value)
					}}
					disabled={disabled}
					className="min-h-[64px]"
				/>
			</div>
		</>
	)
}
